<template>
  <div>
    <h2 class="text-5xl md:text-7xl uppercase font-black leading-none">
      <span class="text-red-600">Thank you!</span> your survey was submitted
    </h2>
    <p class="text-2xl mt-10">
      Your answers will help to build a healthier, more active community
    </p>
    <div
      v-if="survey.thank_you_text"
      class="wysiwyg mt-10"
      v-html="$sanitize(survey.thank_you_text)"
    />
  </div>
</template>
<script>
export default {
  props: {
    survey: {
      type: Object
    }
  }
}
</script>
